var _rect, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": "loading-aria",
    viewBox: "0 0 250 54",
    preserveAspectRatio: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: 0,
    ry: 0,
    width: "100%",
    height: "100%",
    fill: "url(#placeholder_svg__fill)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "placeholder_svg__fill"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2; -2; 1",
    keyTimes: "0; 0.25; 1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 1.6,
    stopColor: "#e8e7e6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1; -1; 2",
    keyTimes: "0; 0.25; 1",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: 2.6,
    stopColor: "#fff"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0; 0; 3",
    keyTimes: "0; 0.25; 1",
    dur: "1s",
    repeatCount: "indefinite"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyByb2xlPSJpbWciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGFyaWEtbGFiZWxsZWRieT0ibG9hZGluZy1hcmlhIiB2aWV3Qm94PSIwIDAgMjUwIDU0IiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIgogICAgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogICAgPHRpdGxlIGlkPSJsb2FkaW5nLWFyaWEiPkxvYWRpbmcuLi48L3RpdGxlPgogICAgPHJlY3QgeD0iMCIgeT0iMCIgcng9IjAiIHJ5PSIwIiB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2ZpbGwpIj48L3JlY3Q+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImZpbGwiPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjAuNTk5OTY0IiBzdG9wLWNvbG9yPSIjZmZmZmZmIiBzdG9wLW9wYWNpdHk9IjEiPgogICAgICAgICAgICAgICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0ib2Zmc2V0IiB2YWx1ZXM9Ii0yOyAtMjsgMSIga2V5VGltZXM9IjA7IDAuMjU7IDEiIGR1cj0iMXMiCiAgICAgICAgICAgICAgICAgICAgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiPjwvYW5pbWF0ZT4KICAgICAgICAgICAgPC9zdG9wPgogICAgICAgICAgICA8c3RvcCBvZmZzZXQ9IjEuNTk5OTYiIHN0b3AtY29sb3I9IiNlOGU3ZTYiIHN0b3Atb3BhY2l0eT0iMSI+CiAgICAgICAgICAgICAgICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJvZmZzZXQiIHZhbHVlcz0iLTE7IC0xOyAyIiBrZXlUaW1lcz0iMDsgMC4yNTsgMSIgZHVyPSIxcyIKICAgICAgICAgICAgICAgICAgICByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlPgogICAgICAgICAgICA8L3N0b3A+CiAgICAgICAgICAgIDxzdG9wIG9mZnNldD0iMi41OTk5NiIgc3RvcC1jb2xvcj0iI2ZmZmZmZiIgc3RvcC1vcGFjaXR5PSIxIj4KICAgICAgICAgICAgICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9Im9mZnNldCIgdmFsdWVzPSIwOyAwOyAzIiBrZXlUaW1lcz0iMDsgMC4yNTsgMSIgZHVyPSIxcyIKICAgICAgICAgICAgICAgICAgICByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSI+PC9hbmltYXRlPgogICAgICAgICAgICA8L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KPC9zdmc+Cg==";
export { SvgPlaceholder as ReactComponent };